{
    "raporsatiskalangun": {
        "Baslik": "Satış Kalan Gün Raporu",
        "PoliceNo": "Poliçe No",
        "Musteri": "Müşteri",
        "Urun": "Ürün",
        "Kullanici": "Kullanıcı",
        "KalanGun": "Kalan Gün",
        "VadeTarihi": "Vade Tarihi",
        "OdemeSekli": "Ödeme Şekli",
        "Ara": "Filtrele",
        "A1": "Aylık (< 7 Gün)",
        "A3": "Quarter (< 15 Gün)",
        "A6": "Altı Aylık (< 23 Gün)",
        "A12": "Yıllık (< 31 Gün)",
        "Kapsam": "Kapsam"
    }
}
